import React from "react";
import Typography from "../../../../components/ui/typography";
import Carousel from "../../../../components/carousel";
import Slide from "./slide";
import classNames from "./style.module.css";
const slides = [
  {
    date: "29.09.2026 12.00",
    title: "XII. Zeka ve Yetenek Kongresi Kayıtları Başladı",
    text: "Ankara’da sonbahar bir başka sevilir. Tam 12 senedir Ankara’da sonbahar, aynı zamanda da kongre demektir. Türkiye Zeka Vakfı ve ODTÜ Eğitim Fakültesi iş birliğiyle ve Türkiye İş Bankasının ana sponsorluğuyla düzenlenen XII. Zeka ve Yetenek Kongresi’nde yine dolu dolu bir program bizleri bekliyor! Kayıt için aşağıdaki bağlantıya tıklayabilirsiniz.",
    url: "https://www.kongre.tzv.org.tr/2026/",
    linkTitle: "Zeka ve Yetenek Kongresi 2026",
  },
  //kanal linki güncelle
  {
    date: "28.09.2025 12.00",
    title: "Whatsapp Duyuru Kanalımız Yayında",
    text: " Şampiyona ile ilgili tüm duyuru ve hatırlatmalar için aşağıdaki bağlantıya tıklayarak Whatsapp kanalımıza üye olabilirsiniz. Üyelerin ad-soyad-telefon bilgileri gizlidir, kanal üzerinde paylaşılmaz. Dilediğiniz zaman kanaldan ayrılabilirsiniz.",
    url: "https://whatsapp.com/channel/0029VaIl6730Qeak6SX1yh1M",
    linkTitle: "Whatsapp Duyuru Kanalı",
  },
];

const Updates = () => (
  <div className={classNames.updates}>
    <Typography color="orange" size="bigger">
      Güncellemeler
    </Typography>
    <Typography color="white" className={classNames.description}>
      Yarışma hakkındaki güncelleme ve gelişmeleri buradan takip edebilirsiniz.
    </Typography>
    <Carousel
      slides={slides.map((slide, key) => (
        <Slide {...slide} key={key} />
      ))}
    />
  </div>
);

export default Updates;
